module.exports = __webpack_public_path__ + "img/cancel.af748cc8.svg";